import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';

import Modal from '@mui/material/Modal';
import AdressList from './AdressList';
import './../../../Styles/Cart/AddressListModel.css';

function AddressListModel({ handleClose, open, handleUpdateDeliveryAddress,selectedAddressIndex, setSelectedAddressIndex }) {
    const [animateModal, setAnimateModal] = useState(false);
    const [closing, setClosing] = useState(false);

    useEffect(() => {
        if (open) {
            setAnimateModal(true);
            setClosing(false);
        }
    }, [open]);

    const handleModalClose = () => {
        setClosing(true);
        setTimeout(() => {
            setAnimateModal(false);
            handleClose();
        }, 300);
    };
    return (
        <div>
            <Modal
                open={open}
                onClose={handleModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className= {`styleAddressModel style ${animateModal ? 'animate' : ''} ${closing ? 'close' : ''}`}>
                    <AdressList
                        handleClose={handleModalClose}
                        handleUpdateDeliveryAddress={handleUpdateDeliveryAddress}
                        selectedAddressIndex={selectedAddressIndex}
                        setSelectedAddressIndex={setSelectedAddressIndex}
                    />
                </Box>
            </Modal>
        </div>
    );
}

export default AddressListModel;
